/* ---------------------------------------------------------------
   A gaveta do carrinho — Moopey, 23/08/2026

   O tema (Symmetry) já faz a parte difícil: intercepta o formulário, envia por
   AJAX e chama `theme.addedToCartHandler`. **Não se lhe mexe nisso** — troca-se
   só o que ele faz no fim, que era mostrar uma barra ao cimo do ecrã com uma
   linha só. Reescrever a submissão do formulário numa loja que está a vender
   seria arriscar o que já funciona.

   **Quem desenha é o Liquid.** A gaveta inteira vem do `?sections=mvn-gaveta`,
   sugestões incluídas. Este ficheiro só abre, fecha e volta a pedir.

   Duas versões ficaram pelo caminho e vale a pena saber porquê: a primeira
   trazia as sugestões em JSON e formatava os preços com o `formatMoney` do
   tema — que rebenta se lhe chamarem sem o formato da moeda, e a caixa ficava
   vazia sem dizer nada. A segunda pedia-as a uma secção à parte pelo
   `/recommendations`, mas essa não sabe o que está no cesto e sugeria o que
   ele acabara de levar. Dinheiro, línguas e o que está no carrinho são com o
   Liquid.

   **Há duas jQuery na página** — a do tema e a de uma app. Por isso aqui não
   se usa jQuery nenhuma: só DOM, que não engana.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var SECCAO = 'mvn-gaveta';
  var gaveta, veu;

  function montar() {
    veu = document.querySelector('.mvn-veu');
    gaveta = document.querySelector('.mvn-gaveta');
    return !!(gaveta && veu);
  }

  function pedir(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; });
  }

  /* a Shopify embrulha a seccao num <div id="shopify-section-..."> */
  function desembrulhar(html) {
    var caixa = document.createElement('div');
    caixa.innerHTML = html;
    var dentro = caixa.querySelector('[id^="shopify-section-"]');
    return dentro ? dentro.innerHTML : caixa.innerHTML;
  }

  /* ---------- abrir e fechar ---------- */
  function abrir() {
    if (!gaveta && !montar()) return;
    // o tema tem o seu proprio aviso ao cimo do ecra; se estiver la, tira-se
    if (window.theme && typeof theme.removeAddedCartDrawer === 'function') {
      try { theme.removeAddedCartDrawer(); } catch (e) {}
    }
    veu.classList.add('aberta');
    gaveta.classList.add('aberta');
    document.documentElement.style.overflow = 'hidden';
    var f = gaveta.querySelector('.mvn-gaveta__fechar');
    if (f) f.focus({ preventScroll: true });
  }

  function fechar() {
    if (!gaveta) return;
    veu.classList.remove('aberta');
    gaveta.classList.remove('aberta');
    document.documentElement.style.overflow = '';
  }

  /* ---------- voltar a desenhar ---------- */
  function redesenhar() {
    return pedir('?sections=' + SECCAO)
      .then(function (txt) {
        if (!txt) return;
        var j;
        try { j = JSON.parse(txt); } catch (e) { return; }
        if (!j[SECCAO]) return;
        gaveta.innerHTML = desembrulhar(j[SECCAO]);
        contaNoCabecalho();
        cronometro();
      });
  }

  /* o numero do saco no cabecalho do tema, para nao ficar a mentir */
  function contaNoCabecalho() {
    var n = gaveta.querySelector('.mvn-gaveta__conta');
    if (!n) return;
    var quantos = n.textContent.trim();
    document.querySelectorAll('.cart-link__bubble-num, .cart-count, [data-cart-count]')
      .forEach(function (e) { e.textContent = quantos; });
  }

  /* ---------- sugestoes ----------
     Ja nao ha nada a fazer aqui: os mais vendidos sao desenhados dentro da
     propria seccao, em Liquid, porque so ai se sabe o que esta no cesto para
     nao o sugerir outra vez. A versao anterior pedia-os ao
     `/recommendations` e nao conseguia excluir o que ele acabara de levar. */

  /* ---------- o cronometro da urgencia ----------
     Dez minutos. **A hora de arranque vive no `sessionStorage`**, nao numa
     variavel: a gaveta e redesenhada de cada vez que o carrinho muda, e sem
     isto o relogio voltava aos 10:00 a cada clique — que se ve logo que e
     falso. Assim conta do primeiro momento em que ele poe alguma coisa no
     cesto, e so recomeca quando fechar o separador. */
  var CHAVE_CRON = 'mvnCronDesde';
  var relogio = null;

  function cronometro() {
    var caixa = gaveta.querySelector('[data-mvn-cron]');
    var alvo = gaveta.querySelector('[data-mvn-cron-n]');
    clearInterval(relogio);
    if (!caixa || !alvo) return;

    var desde;
    try { desde = parseInt(sessionStorage.getItem(CHAVE_CRON), 10); } catch (e) { desde = null; }
    if (!desde || isNaN(desde)) {
      desde = Date.now();
      try { sessionStorage.setItem(CHAVE_CRON, String(desde)); } catch (e) {}
    }

    function tique() {
      var resta = 600 - Math.floor((Date.now() - desde) / 1000);
      if (resta <= 0) {           // acabou: volta a contar, nao fica em 00:00
        desde = Date.now();
        try { sessionStorage.setItem(CHAVE_CRON, String(desde)); } catch (e) {}
        resta = 600;
      }
      var mm = Math.floor(resta / 60), ss = resta % 60;
      alvo.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
    }
    tique();
    relogio = setInterval(tique, 1000);
  }

  /* ---------- um pedido so ----------
     06/10: **o carrinho e a gaveta vem na mesma resposta.** O /cart/*.js da
     Shopify aceita `sections` e devolve a seccao ja desenhada com o carrinho
     novo. Antes eram dois pedidos em fila (mexer no carrinho, depois pedir a
     gaveta), e o seguro levava 1 a 2 s no computador e mais no telemovel. */
  function enviar(url, corpo) {
    corpo.sections = SECCAO;
    corpo.sections_url = location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  /* desenha a gaveta com o que veio na resposta; se nao veio, pede-a */
  function pintar(r) {
    if (r && r.sections && r.sections[SECCAO]) {
      gaveta.innerHTML = desembrulhar(r.sections[SECCAO]);
      contaNoCabecalho();
      cronometro();
      return Promise.resolve();
    }
    return redesenhar();
  }

  /* ---------- seguro de envio ----------
     Nao e uma opcao do carrinho: e um produto (`parcel-insurance`).
     06/10: **o visto muda no proprio clique** (antes so mudava quando a gaveta
     voltava do servidor) e vai um pedido so, ao /cart/update.js, que poe a 1
     ou a 0 — serve para ligar e para desligar. Cliques seguidos vao em fila e
     so a ultima resposta redesenha, para o visto nunca saltar para tras. */
  var filaSeguro = Promise.resolve(), seguroPendentes = 0;
  function seguro(caixa) {
    var idVariante = caixa.getAttribute('data-mvn-seguro');
    var ligar = caixa.checked;
    var etiqueta = caixa.closest('.mvn-seguro');
    if (etiqueta) etiqueta.classList.toggle('ligado', ligar);
    gaveta.classList.add('a-contar');
    var updates = {}; updates[idVariante] = ligar ? 1 : 0;
    seguroPendentes++;
    filaSeguro = filaSeguro
      .then(function () { return enviar('/cart/update.js', { updates: updates }); })
      .then(function (r) {
        if (--seguroPendentes === 0) return pintar(r).then(function () { gaveta.classList.remove('a-contar'); });
      }, function () {
        if (--seguroPendentes === 0) return redesenhar().then(function () { gaveta.classList.remove('a-contar'); });
      });
    return filaSeguro;
  }

  /* ---------- mexer no carrinho ---------- */
  function mudar(chave, quantidade) {
    gaveta.classList.add('a-trabalhar');
    return enviar('/cart/change.js', { id: chave, quantity: quantidade })
      .then(pintar, function () { return redesenhar(); })
      .then(function () { gaveta.classList.remove('a-trabalhar'); })
      .catch(function () { gaveta.classList.remove('a-trabalhar'); });
  }

  /* As sugestoes, como na Devano: se o produto tem variantes, as listas por
     baixo do cartao dizem qual — junta-se a variante que bate com o que esta
     escolhido. */
  function varianteEscolhida(botao) {
    var cartao = botao.closest('.mvn-up');
    var caixa = cartao && cartao.querySelector('[data-mvn-opcoes]');
    if (!caixa) return botao.getAttribute('data-mvn-juntar');
    var d;
    try { d = JSON.parse(caixa.querySelector('script').textContent); } catch (e) { return null; }
    var sel = [].map.call(caixa.querySelectorAll('select'), function (x) { return x.value; }).join('|');
    for (var i = 0; i < d.o.length; i++) {
      if (d.o[i].join('|') === sel) {
        /* o preco e a foto acompanham a escolha */
        var preco = cartao.querySelector('.mvn-up__p');
        if (preco && d.p && d.p[i]) preco.innerHTML = d.p[i];
        var foto = cartao.querySelector('.mvn-up__img img');
        if (foto && d.m && d.m[i]) foto.src = d.m[i];
        return d.a[i] ? d.i[i] : null;
      }
    }
    return null;
  }

  function juntar(idVariante, botao) {
    if (!idVariante) return;
    botao.disabled = true;
    return enviar('/cart/add.js', { items: [{ id: Number(idVariante), quantity: 1 }] })
      .then(pintar, function () { return redesenhar(); })
      .catch(function () { botao.disabled = false; });
  }

  /* ---------- ligacoes ---------- */
  function ligar() {
    if (!montar()) return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('.mvn-gaveta__fechar') || e.target.classList.contains('mvn-veu')) {
        e.preventDefault(); fechar(); return;
      }

      // o saco do cabecalho abre a gaveta em vez de ir para /cart
      var saco = e.target.closest('a[href$="/cart"], a[href*="/cart?"], .cart-link, #cart-drawer-toggle');
      if (saco && !e.target.closest('.mvn-gaveta')) {
        e.preventDefault();
        gaveta.classList.add('a-trabalhar');
        abrir();
        redesenhar().then(function () { gaveta.classList.remove('a-trabalhar'); })
                    .catch(function () { gaveta.classList.remove('a-trabalhar'); });
        return;
      }

      var b = e.target.closest('[data-mvn-qtd]');
      if (b) {
        e.preventDefault();
        var linha = b.closest('.mvn-linha');
        if (!linha) return;
        /* 06/10: uma linha a vista pode ser varias linhas verdadeiras (a Shopify
           parte-as quando o desconto so cabe a uma unidade). `data-partes` diz
           quais: «chave:qtd,chave:qtd». */
        var partes = (linha.getAttribute('data-partes') || '').split(',').filter(Boolean)
          .map(function (x) { var i = x.lastIndexOf(':'); return [x.slice(0, i), +x.slice(i + 1) || 0]; });
        if (!partes.length) partes = [[linha.getAttribute('data-chave'), parseInt(linha.querySelector('.mvn-passo__n').textContent, 10) || 1]];
        var acao = b.getAttribute('data-mvn-qtd');
        if (acao === 'tirar') {
          var up = {}; partes.forEach(function (p) { up[p[0]] = 0; });
          gaveta.classList.add('a-trabalhar');
          enviar('/cart/update.js', { updates: up }).then(pintar, function () { return redesenhar(); })
            .then(function () { gaveta.classList.remove('a-trabalhar'); }, function () { gaveta.classList.remove('a-trabalhar'); });
          return;
        }
        if (acao === 'menos') { var u = partes[partes.length - 1]; mudar(u[0], Math.max(0, u[1] - 1)); return; }
        if (acao === 'mais') { var p0 = partes[0]; mudar(p0[0], p0[1] + 1); return; }
      }

      var j = e.target.closest('button[data-mvn-juntar]');
      if (j) { e.preventDefault(); juntar(varianteEscolhida(j), j); }
    });

    document.addEventListener('change', function (e) {
      var c = e.target.closest('[data-mvn-seguro]');
      if (c) { seguro(c); return; }
      /* trocar a marca ou a cor numa sugestao: o botao so fica activo se essa
         combinacao existir e houver stock */
      var o = e.target.closest('[data-mvn-opcoes] select');
      if (o) {
        var bt = o.closest('.mvn-up').querySelector('button[data-mvn-juntar]');
        if (bt) bt.disabled = !varianteEscolhida(bt);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && gaveta.classList.contains('aberta')) fechar();
    });

    /* **o encaixe no tema.** O Symmetry chama isto depois de por no carrinho.
       Deixa-se o dele correr primeiro (actualiza contadores e o botao) e so se
       lhe acrescenta a gaveta no fim — assim, se um dia isto falhar, a loja
       continua a vender como vendia. */
    if (window.theme && typeof theme.addedToCartHandler === 'function') {
      var original = theme.addedToCartHandler;
      theme.addedToCartHandler = function () {
        try { original.apply(this, arguments); } catch (err) {}
        try { theme.removeAddedCartDrawer(); } catch (err) {}
        /* **Abre-se JA, nao depois de o servidor responder.** Esperar pela
           resposta deixava um segundo em que nao acontecia nada — e nesse
           intervalo via-se a barra do tema a deslizar pela pagina. Abre-se
           logo, com o conteudo apagado e um pinhao a rodar, e o conteudo
           entra durante a propria animacao de entrada. */
        gaveta.classList.add('a-trabalhar');
        abrir();
        redesenhar().then(function () { gaveta.classList.remove('a-trabalhar'); })
                    .catch(function () { gaveta.classList.remove('a-trabalhar'); });
      };
    }

    cronometro();

    // se outra coisa qualquer mexer no carrinho, a gaveta acompanha
    document.documentElement.addEventListener('theme:cartchanged', function () {
      if (gaveta.classList.contains('aberta')) redesenhar();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }
})();


/* ------------------------------------------------------------------ */
/* A barra na moeda de quem esta a ver                                 */
/* ------------------------------------------------------------------ */
/*
 * O Liquid desenhou a barra com os degraus em centimos da moeda da LOJA, e o
 * total do cesto vem na moeda do CLIENTE. Sao reguas diferentes: em coroas um
 * cesto de 849 comparava-se com 11990 e a barra prometia o que a loja nao dava.
 *
 * A taxa nao existe em Liquid — quem a sabe e o navegador. Aqui converte-se os
 * degraus e refaz-se o que o Liquid escreveu.
 *
 * **Se a moeda e a do proprio loja, este ficheiro nao toca em nada.** E o caso
 * de 87,5% da Livena e de toda a Moopey e Elegato: sai na primeira linha.
 *
 * E um custom element porque a gaveta e redesenhada pelo `?sections=` a cada
 * mudanca do carrinho — um `<script>` na seccao nao voltava a correr.
 */
if (!customElements.get('mvn-moeda')) {
  class MvnMoeda extends HTMLElement {
    connectedCallback() {
      var taxa = parseFloat(
        (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1
      );
      if (!(taxa > 0) || Math.abs(taxa - 1) < 1e-9) return;

      var barra = this.querySelector('.mvn-barra');
      if (!barra) return;

      var total = parseInt(this.dataset.total, 10) || 0;
      var d1 = Math.round(parseInt(this.dataset.degrau1, 10) * taxa);
      var d2 = Math.round(parseInt(this.dataset.degrau2, 10) * taxa);
      if (!d2) return;

      var estado = total >= d2 ? 'ganho' : total >= d1 ? 'meio' : 'inicio';
      var frase =
        estado === 'ganho'
          ? this.dataset.ganhou || ''
          : (estado === 'meio' ? this.dataset.falta2 : this.dataset.falta1 || '').replace(
              '@@',
              this.dinheiro(estado === 'meio' ? d2 - total : d1 - total)
            );

      barra.className = 'mvn-barra mvn-barra--' + estado;

      var caixa = barra.querySelector('.mvn-barra__frase');
      if (caixa) {
        var ico = caixa.querySelector('.mvn-barra__ico');
        caixa.textContent = '';
        if (ico) {
          ico.textContent = estado === 'ganho' ? '🎉' : '🎁';
          caixa.appendChild(ico);
        }
        caixa.appendChild(document.createTextNode(' ' + frase));
      }

      var cheio = Math.min(100, (total * 100) / d2);
      var risco = barra.querySelector('.mvn-barra__calha i');
      if (risco) risco.style.width = cheio + '%';

      var marcas = barra.querySelectorAll('.mvn-barra__marca');
      if (marcas[0]) marcas[0].classList.toggle('atingida', total >= d1);
      if (marcas[1]) marcas[1].classList.toggle('atingida', total >= d2);

      /* As legendas por baixo: quanto e preciso, quanto se ganha, e o visto. */
      var degs = barra.querySelectorAll('.mvn-barra__deg');
      var pcts = [this.dataset.pct1 || '', this.dataset.pct2 || ''];
      [d1, d2].forEach(
        function (valor, i) {
          if (!degs[i]) return;
          var ganho = total >= valor;
          degs[i].classList.toggle('atingido', ganho);
          degs[i].textContent =
            this.dinheiro(valor) + ' · ' + pcts[i] + (ganho ? ' ✓' : '');
        }.bind(this)
      );
    }

    /*
     * O `money` do Liquid escreve no formato da moeda da loja. Quem manda e a
     * moeda que o cliente tem escolhida, e o proprio navegador sabe formata-la.
     */
    dinheiro(centimos) {
      var moeda = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      var lingua = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
      try {
        return new Intl.NumberFormat(lingua, {
          style: 'currency',
          currency: moeda,
          minimumFractionDigits: 2
        }).format(centimos / 100);
      } catch (e) {
        return (centimos / 100).toFixed(2) + ' ' + moeda;
      }
    }
  }

  customElements.define('mvn-moeda', MvnMoeda);
}
